// --- Archivo: Cohortes.jsx (COMPLETO Y CORREGIDO) ---

import { useState, useEffect, useRef } from 'react';
import Fecha from './Fecha';
import SubtituloPrincipal from './fonts/SubtituloPrincipal';
import Button from '../components/UIElements/FabAlargado';
import BtnEliminar from '../components/UIElements/BotonCircular';
import { Divider, Typography, Box } from '@mui/material';
import { getCalendarioRestricciones } from '../services/instancias.service.js';

// Renombrado a Cohortes (con mayúscula)
const Cohortes = ({
    getCohortes,
    esCampusCordoba,
    esExcepcionParaFechas = false,
    instanciasExistentes = [],
    erroresCohortes = {},
    errorSinCohortes = "",
    onRevalidateCohortes,
    onClearSinCohortes,
}) => {

    const titulo = "Cohortes";
    const mensajeDesdeInscripcion = "Fecha de Inscripción desde";
    const mensajeHastaInscripcion = "Fecha de Inscripción hasta";
    const mensajeDesdeCursada = "Fecha de Cursada desde";
    const mensajeHastaCursada = "Fecha de Cursada hasta";

    // El estado ahora es local y se resetea cuando la 'key' cambia
    const [cohortes, setCohortes] = useState([]);
    const nextCohortIdRef = useRef(1);

    // Pre-cargar y refrescar en segundo plano las restricciones de fechas al montar el formulario
    useEffect(() => {
        getCalendarioRestricciones(true).catch((error) => {
            console.error('Error al pre-cargar restricciones de fechas:', error);
        });
    }, []);

    const agregarCohorte = () => {
        const nuevoCohorte = {
            id: nextCohortIdRef.current++, // ID único monotónico que no se reutiliza al borrar
            fechaInscripcionDesde: "",
            fechaInscripcionHasta: "",
            fechaCursadaDesde: "",
            fechaCursadaHasta: "",
        };
        const nuevasCohortes = [...cohortes, nuevoCohorte];
        setCohortes(nuevasCohortes);
        getCohortes(nuevasCohortes); // Notificar al padre
        if (onClearSinCohortes) {
            onClearSinCohortes();
        }
        if (onRevalidateCohortes) {
            onRevalidateCohortes(nuevasCohortes, { type: 'add', cohorteId: nuevoCohorte.id });
        }
    };

    const eliminarCohorte = (id) => {
        const updatedCohortes = cohortes.filter(cohorte => cohorte.id !== id);
        setCohortes(updatedCohortes);
        getCohortes(updatedCohortes); // Notificar al padre
        if (onRevalidateCohortes) {
            onRevalidateCohortes(updatedCohortes, { type: 'remove', cohorteId: id });
        }
    };

    const handleFechas = (newDate, id, fieldFecha) => {
        const updatedCohortes = cohortes.map((cohorte) =>
            cohorte.id === id ? { ...cohorte, [fieldFecha]: newDate } : cohorte
        );
        setCohortes(updatedCohortes);
        getCohortes(updatedCohortes); // Notificar al padre
        if (onRevalidateCohortes) {
            onRevalidateCohortes(updatedCohortes, { type: 'change', cohorteId: id, fieldFecha });
        }
    };

    return (
        <>
            <div className="container-cohorte">
                <div className='titulo'><SubtituloPrincipal texto={titulo} /></div>
                <Divider sx={{ marginBottom: 2, borderBottomWidth: 2, borderColor: errorSinCohortes ? 'error.main' : 'black' }} />

                {cohortes.map((cohorte, index) => {
                    const cohorteAnterior = index > 0 ? cohortes[index - 1] : null;
                    const erroresDeCohorte = erroresCohortes[cohorte.id] || {};

                    return (
                        <Box className='cohortes' key={cohorte.id} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flexWrap: { xs: 'wrap', md: 'nowrap' }, mb: 2, '& > div': { mb: 0 } }}>
                            <div className='label'>
                                <Typography variant="body1" sx={{ mt: 4 }}>{`Cohorte N° ${index + 1}: `}</Typography>
                            </div>
                            <div className="insc-desde" style={{ flex: 1 }}>
                                <Fecha
                                    mensaje={mensajeDesdeInscripcion}
                                    getFecha={handleFechas}
                                    id={cohorte.id}
                                    fieldFecha="fechaInscripcionDesde"
                                    value={cohorte.fechaInscripcionDesde}
                                    error={Boolean(erroresDeCohorte.fechaInscripcionDesde)}
                                    helperText={erroresDeCohorte.fechaInscripcionDesde}
                                />
                            </div>
                            <div className="insc-hasta" style={{ flex: 1 }}>
                                <Fecha
                                    mensaje={mensajeHastaInscripcion}
                                    getFecha={handleFechas}
                                    id={cohorte.id}
                                    fieldFecha="fechaInscripcionHasta"
                                    value={cohorte.fechaInscripcionHasta}
                                    error={Boolean(erroresDeCohorte.fechaInscripcionHasta)}
                                    helperText={erroresDeCohorte.fechaInscripcionHasta}
                                />
                            </div>
                            <div className="curso-desde" style={{ flex: 1 }}>
                                <Fecha
                                    mensaje={mensajeDesdeCursada}
                                    getFecha={handleFechas}
                                    id={cohorte.id}
                                    fieldFecha="fechaCursadaDesde"
                                    value={cohorte.fechaCursadaDesde}
                                    esCampusCordoba={esCampusCordoba}
                                    esExcepcionParaFechas={esExcepcionParaFechas}
                                    fechaHastaAnterior={cohorteAnterior?.fechaCursadaHasta}
                                    instanciasExistentes={instanciasExistentes}
                                    error={Boolean(erroresDeCohorte.fechaCursadaDesde)}
                                    helperText={erroresDeCohorte.fechaCursadaDesde}
                                />
                            </div>
                            <div className="curso-hasta" style={{ flex: 1 }}>
                                <Fecha
                                    mensaje={mensajeHastaCursada}
                                    getFecha={handleFechas}
                                    id={cohorte.id}
                                    fieldFecha="fechaCursadaHasta"
                                    value={cohorte.fechaCursadaHasta}
                                    esCampusCordoba={esCampusCordoba}
                                    esExcepcionParaFechas={esExcepcionParaFechas}
                                    fechaDesdeActual={cohorte.fechaCursadaDesde}
                                    instanciasExistentes={instanciasExistentes}
                                    error={Boolean(erroresDeCohorte.fechaCursadaHasta)}
                                    helperText={erroresDeCohorte.fechaCursadaHasta}
                                />
                            </div>
                            <Box className="icon" sx={{ display: 'flex', alignItems: 'center', mt: 3.5 }}>
                                <BtnEliminar icon={"borrar"} width={40} height={40} justifyContent={"center"} alignItems={"center"} onClick={() => eliminarCohorte(cohorte.id)} />
                            </Box>
                        </Box>
                    );
                })}

                <div className='btnEnviar'>
                    <Button mensaje={"Agregar Cohorte"} icon={"signoMas"} onClick={agregarCohorte} justifyContent={"flex-start"}></Button>
                    {errorSinCohortes && (
                        <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1, ml: 0.5, fontWeight: 500, fontSize: '0.82rem' }}>
                            {errorSinCohortes}
                        </Typography>
                    )}
                </div>
            </div>
        </>
    );
};

export default Cohortes;
